import { render, staticRenderFns } from "./UnlockBag.vue?vue&type=template&id=166334b9&scoped=true&"
import script from "./UnlockBag.vue?vue&type=script&lang=js&"
export * from "./UnlockBag.vue?vue&type=script&lang=js&"
import style0 from "./UnlockBag.vue?vue&type=style&index=0&id=166334b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166334b9",
  null
  
)

export default component.exports